import classNames from 'classnames'
import { Investment as InvestmentType } from 'entities-next/fundingRounds'
import { noop } from 'lodash'
import PencilIcon from 'mdi-react/PencilIcon'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { FormViews, useEdition } from 'utils-next/forms'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Card, CardContent, IconButton, Theme } from '@mui/material'

import { InvestmentForm, InvestmentView } from './components'

export type InvestmentProps = ExtendableStyles &
  Testable & {
    data: InvestmentType
    editable?: boolean
    initialView?: FormViews
    onDelete?: () => void
    onUpdate?: (data: InvestmentType) => Promise<any> | any
  }

export function Investment({
  className,
  data,
  editable = false,
  initialView = FormViews.view,
  onDelete = noop,
  onUpdate = noop,
  ...otherProps
}: InvestmentProps) {
  const { classes } = useStyles()
  const { showEditionButton, enableEdition, disableEdition, view } = useEdition({
    editable,
    initialView,
  })

  const handleFormSubmit = async (data: InvestmentType) => {
    await onUpdate(data)
    disableEdition()
  }

  return (
    <Card className={classNames(className, classes.container)} {...otherProps}>
      {showEditionButton && (
        <IconButton aria-label="edit" onClick={enableEdition} className={classes.editButton}>
          <PencilIcon />
        </IconButton>
      )}
      <CardContent>
        {view === FormViews.edit && <InvestmentForm data={data} onDelete={onDelete} onUpdate={handleFormSubmit} />}
        {view === FormViews.view && <InvestmentView data={data} />}
      </CardContent>
    </Card>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  container: {
    position: 'relative',
  },
  editButton: {
    position: 'absolute',
    right: spacing(),
    top: spacing(),
    zIndex: 2,
  },
}))
